<gk-accessibility-statement
  [statementType]="statementType"
></gk-accessibility-statement>
